import React, {useId, useState} from "react";
import Modal from "./Modal";
import LandingFields, {fieldsHaveErrors, cleanFieldValues} from "./LandingFields";
import {C} from "../styles";
import SECTION_FIELDS from "../landing/sectionFields.json";
import {SECTION_DEFAULTS} from "../landing/sectionDefaults";
import LandingAiDraft, {isDraftable} from "./LandingAiDraft";

const smallButton = {border: `1px solid ${C.border}`, background: "#fff", borderRadius: 6, padding: "4px 9px", cursor: "pointer", fontSize: 13};

// Éditeur des textes d'une rubrique intégrée : formulaire généré depuis le registre (voir LandingFields).
export default function LandingSectionEditor({section, onSave, onClose, aiAvailable = false}) {
    const idBase = useId();
    const info = SECTION_FIELDS[section.type];
    const [values, setValues] = useState(() => ({...section.data}));
    const hasError = fieldsHaveErrors(info.fields, values);

    return (
        <Modal title={`Modifier les textes — ${info.label}`} onClose={onClose} floating>
            <p style={{marginTop: 0, fontSize: 13, color: C.textMuted}}>
                Un champ laissé vide garde le texte d'origine (affiché en grisé). Aucun code : le texte est affiché tel quel.
            </p>
            {isDraftable("section", section.type) && (
                <LandingAiDraft scope="section" type={section.type} current={values} disabled={!aiAvailable}
                                onApply={(proposed) => setValues(v => ({...v, ...proposed}))}/>
            )}
            <LandingFields fields={info.fields} values={values} defaults={SECTION_DEFAULTS[section.type]} idBase={idBase} onChange={setValues}/>
            <div style={{display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 12}}>
                <button type="button" onClick={onClose} style={smallButton}>Annuler</button>
                <button type="button" onClick={() => onSave(cleanFieldValues(values))} disabled={hasError}
                        style={{...smallButton, background: hasError ? "#ccc" : C.primary, color: "#fff", border: "none", cursor: hasError ? "not-allowed" : "pointer"}}>
                    Enregistrer
                </button>
            </div>
        </Modal>
    );
}
